import styled from 'styled-components';

export const PageTitle = styled.h1`
  font-size: 26px;
  margin-top: 0;
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-weight: ${(props) => props.theme.typography.fontWeightBold};
`;
